import type { ColumnSchema } from '../types'

export const COLUMN_WIDTH_DATETIME = 150
export const COLUMN_WIDTH_IMAGE = 70
export const COLUMN_WIDTH_STATUS = 140
export const COLUMN_WIDTH_AMOUNT = 120
export const COLUMN_WIDTH_TEL = 130
export const COLUMN_WIDTH_DEFAULT = 180

export function resolveColumnWidth(
  column: Pick<ColumnSchema, 'width' | 'type'>,
): number {
  if (column.width != null) return column.width

  if (column.type === 'datetime') return COLUMN_WIDTH_DATETIME
  if (column.type === 'image') return COLUMN_WIDTH_IMAGE
  if (column.type === 'status') return COLUMN_WIDTH_STATUS
  if (column.type === 'amount') return COLUMN_WIDTH_AMOUNT
  if (column.type === 'tel') return COLUMN_WIDTH_TEL
  if (column.type === 'date') return COLUMN_WIDTH_DATETIME

  return COLUMN_WIDTH_DEFAULT
}

/** Percent widths that keep relative proportions and fill the table. */
export function columnWidthPercents(widths: number[]): number[] {
  const total = widths.reduce((sum, width) => sum + width, 0)
  if (total <= 0) {
    const even = widths.length > 0 ? 100 / widths.length : 0
    return widths.map(() => even)
  }
  return widths.map((width) => (width / total) * 100)
}
